/**
 * ErrorBoundary da aplicação (rodada 23/09/2026 — a tela branca): qualquer erro
 * de render em qualquer página derrubava a árvore INTEIRA (não havia boundary
 * em lugar nenhum). A raiz (main.tsx) envolve a App com este componente: o erro
 * vira um cartão amigável com a mensagem e o botão "Recarregar", em vez da
 * página em branco.
 */
import { Component, type ReactNode } from "react";
import { Alert, Button, Paper, Text } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";

export class ErrorBoundary extends Component<{ children: ReactNode }, { erro: Error | null }> {
  override state = { erro: null as Error | null };

  static getDerivedStateFromError(erro: Error) {
    return { erro };
  }

  override componentDidCatch(erro: Error, info: { componentStack?: string | null }) {
    // trilha no console do navegador (o usuário vê o cartão amigável)
    console.error("[ErrorBoundary] erro de render:", erro, info.componentStack ?? "");
  }

  override render() {
    const { erro } = this.state;
    if (erro) {
      return (
        <Paper m="xl" p="xl" withBorder radius="md" role="alert">
          <Alert color="red" title="Algo inesperado aconteceu" mb="md">
            <Text size="sm" mb={4}>
              A tela encontrou um erro e não conseguiu continuar. Nada foi gravado por causa disso.
            </Text>
            <Text size="xs" c="dimmed" style={{ fontFamily: "monospace" }}>
              {erro.message}
            </Text>
          </Alert>
          <Button leftSection={<IconRefresh size={16} />} onClick={() => window.location.reload()}>
            Recarregar
          </Button>
        </Paper>
      );
    }
    return this.props.children;
  }
}
